/* ADSCALAR — welcome popup behaviour. Delayed reveal, localStorage suppression,
   focus trap, Escape/scrim close. Never reveals during the LCP window. */
(function () {
  var KEY = 'asc-pop-suppressed-until';

  var root = document.querySelector('[data-asc-pop-root]');
  if (!root) return;

  var dialog = root.querySelector('[data-asc-pop]');
  var scrim = root.querySelector('[data-asc-pop-scrim]');
  var delayMs = (parseInt(root.getAttribute('data-delay'), 10) || 0) * 1000;
  var suppressDays = parseInt(root.getAttribute('data-suppress-days'), 10) || 30;

  var designMode = !!(window.Shopify && window.Shopify.designMode);
  if (!designMode && document.querySelector('.asc-pdp')) {
    root.hidden = true;
    return;
  }
  var lastFocused = null;
  var timer = null;
  var isOpen = false;

  // Shopify redirects back with ?customer_posted=true after a successful
  // customer form post, so the success state has to be shown straight away
  // rather than waiting out the delay again.
  var justPosted = /[?&]customer_posted=true/.test(window.location.search);

  // Once per browsing session: without this, a shopper who simply navigated
  // away from the popup (no close) got it again on every page. Closing it
  // (X, "No thanks", scrim, Escape) or signing up applies the long
  // localStorage suppression below.
  var SESSION_KEY = 'asc-pop-shown';
  var COMMERCE_KEY = 'asc-pop-commerce-suppressed';

  function suppressed() {
    if (designMode) return false; // always previewable in the editor
    try {
      if (window.sessionStorage.getItem(COMMERCE_KEY)) return true;
      if (window.sessionStorage.getItem(SESSION_KEY)) return true;
    } catch (e0) {}
    try {
      var until = parseInt(window.localStorage.getItem(KEY), 10);
      return !!until && Date.now() < until;
    } catch (e) {
      return false; // private mode / blocked storage — fail open, still show once
    }
  }

  function markShown() {
    if (designMode) return;
    try { window.sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
  }

  function suppress() {
    if (designMode) return;
    try {
      window.localStorage.setItem(KEY, String(Date.now() + suppressDays * 864e5));
    } catch (e) {}
  }

  function focusables() {
    if (!dialog) return [];
    return Array.prototype.filter.call(
      dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) {
        return !el.disabled && el.offsetParent !== null;
      }
    );
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      close();
      return;
    }
    if (e.key !== 'Tab') return;

    var f = focusables();
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function open() {
    if (isOpen || suppressed()) return;
    isOpen = true;
    lastFocused = document.activeElement;

    root.hidden = false;
    markShown();
    // Next frame so the transition actually runs from the hidden state.
    requestAnimationFrame(function () {
      root.classList.add('open');
    });
    document.body.classList.add('scroll-locked');
    document.addEventListener('keydown', onKeydown);

    // Prefer the email field; fall back to the first focusable (success state).
    var target = dialog && (dialog.querySelector('input[type="email"]') || focusables()[0]);
    if (target) target.focus({ preventScroll: true });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;

    root.classList.remove('open');
    document.body.classList.remove('scroll-locked');
    document.removeEventListener('keydown', onKeydown);
    suppress();

    // Wait out the fade before pulling it from the layout.
    setTimeout(function () {
      if (!isOpen) root.hidden = true;
    }, 450);

    if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
  }

  function suppressForCommerce() {
    if (designMode) return;
    try { window.sessionStorage.setItem(COMMERCE_KEY, '1'); } catch (e) {}
    if (timer) { clearTimeout(timer); timer = null; }
    if (isOpen) {
      isOpen = false;
      root.classList.remove('open');
      root.hidden = true;
      document.body.classList.remove('scroll-locked');
      document.removeEventListener('keydown', onKeydown);
    }
  }

  // Once a shopper starts a buying action, never interrupt that session with
  // Instagram. This covers size selection, cart actions and checkout entry.
  document.addEventListener('click', function (e) {
    if (e.target.closest('.asc-size-cell, [data-atc], [data-buynow], [data-sticky-add], [data-sticky-foot-add], [data-asc-cart-open], [data-asc-cd], button[name="checkout"]')) {
      suppressForCommerce();
    }
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-sticky-size], [data-sticky-foot-size]')) suppressForCommerce();
  }, true);
  window.addEventListener('ek:cart-open', suppressForCommerce);

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-asc-pop-close]')) {
      e.preventDefault();
      close();
      return;
    }
    if (scrim && e.target === scrim) close();
  });

  // Validate before the post so an empty field never round-trips to Shopify
  // and comes back as a bare "can't be blank".
  var form = root.querySelector('form.asc-pop-form');
  var email = form && form.querySelector('input[type="email"]');
  var err = root.querySelector('[data-asc-pop-err]');
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function setError(msg) {
    if (!err) return;
    err.textContent = msg || '';
    err.hidden = !msg;
    if (email) {
      if (msg) email.setAttribute('aria-invalid', 'true');
      else email.removeAttribute('aria-invalid');
    }
  }

  if (form && email) {
    form.addEventListener('submit', function (e) {
      var v = email.value.trim();
      var msg = !v ? 'Enter your email.' : !EMAIL_RE.test(v) ? 'Enter a valid email address.' : '';
      if (msg) {
        e.preventDefault();
        setError(msg);
        email.focus({ preventScroll: true });
      }
    });
    email.addEventListener('input', function () {
      if (err && !err.hidden) setError('');
    });
  }

  // A completed signup shouldn't nag again.
  if (root.querySelector('.asc-pop-ok')) suppress();

  if (justPosted) {
    open();
  } else if (!suppressed()) {
    if (designMode || delayMs === 0) {
      open();
    } else {
      timer = setTimeout(open, delayMs);
      // Don't ambush someone mid-checkout — the cart drawer opening cancels it.
      window.addEventListener('ek:cart-open', function () {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      });
    }
  }

  window.ekPopup = { open: open, close: close };
})();
